<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    :header="{ bgColor: 'secondary', textColor: 'white', icon: 'fad fa-circle-exclamation' }"
    :body="{ class: 'text-center candidate-apply-temporary-modal' }"
    :footer="{ class: 'text-center' }"
    :quasar-props="{
      maximized: false,
      noEscDismiss: true,
      noBackdropDismiss: true,
    }"
    size="sm"
  >
    <template #body>
      <p>
        {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.ADMIN_FOLDER.MODALS.@WARNING_BEFORE_SUBMIT")) }}
      </p>
      <section class="text-center">
        <p class="text-secondary">
          {{ $t("ETAB.PAGES.ADMIN_FOLDER.FORMS.@ETAB_NAME") }}
        </p>
        <p>
          {{ etabAdminFolder.getSocialReason() }}
        </p>
        <hr />
        <p class="text-secondary">
          {{ $t("ETAB.PAGES.ADMIN_FOLDER.FORMS.@SIRET") }}
        </p>
        <p>
          {{ etabAdminFolder.getSiret() }}
        </p>
        <hr />
        <p class="text-secondary">
          {{ $t("ETAB.PAGES.ADMIN_FOLDER.FORMS.@VAT") }}
        </p>
        <p>
          {{ etabAdminFolder.getVat() }}
        </p>
        <hr />
        <p class="text-secondary">
          {{ $t("ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_ADDRESS") }}
        </p>
        <p>
          {{ etabAdminFolder.getAddress() }}
        </p>
        <hr />
        <p class="text-secondary">
          {{ $t("ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_CITY") }}
        </p>
        <p>
          {{ etabAdminFolder.getCity() }}
        </p>
        <hr />
        <p class="text-secondary">
          {{ $t("ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_POSTAL_CODE") }}
        </p>
        <p>
          {{ etabAdminFolder.getPostalCode() }}
        </p>
        <hr />
        <p class="text-secondary">
          {{ $t("ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_COUNTRY") }}
        </p>
        <p>
          {{ etabAdminFolder.getCountry() }}
        </p>
        <hr />
        <p class="text-secondary">
          {{ $t("ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_CONTACT_MAIL") }}
        </p>
        <p>
          {{ etabAdminFolder.getEmail() }}
        </p>
      </section>
    </template>
    <template #footer>
      <QBtn v-close-popup class="btn-large q-mb-sm text-underline" flat no-caps :label="$t('CORE.BUTTONS.@BACK')" />
      <QBtn
        type="button"
        no-caps
        color="secondary"
        :label="$t('ETAB.PAGES.ADMIN_FOLDER.MODALS.@CONFIRM_INFOS_BTN')"
        class="btn-large"
        @click="$emit('saveFolder')"
      />
    </template>
  </ExtracadabraModal>
</template>

<script>
  import { ExtracadabraModal } from "@core/components/modals";
  import { EtabAdminFolderModel } from "@core/models";

  export default {
    components: {
      ExtracadabraModal,
    },
    props: {
      etabAdminFolder: {
        type: Object,
        default: () => new EtabAdminFolderModel(),
      },
      opened: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:opened", "saveFolder"],
    computed: {
      internalOpen: {
        get() {
          return this.opened;
        },
        set(value) {
          this.$emit("update:opened", value);
        },
      },
    },
  };
</script>
